import React, {PureComponent, Fragment} from 'react';
import {
    Divider,
    ListSubheader,
    ListItem,
    ListItemText,
    ListItemIcon,
    IconButton,
    List,
    Button,
    ListItemSecondaryAction,
    Tooltip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
} from '@material-ui/core'
import PlayArrowIcon from '@material-ui/icons/PlayArrow'
import RemoveIcon from '@material-ui/icons/RemoveCircleOutline';
import ReplayIcon from '@material-ui/icons/Replay';
import Shuffle from '@material-ui/icons/Shuffle';
import StarBorder from '@material-ui/icons/StarBorder';
import Star from '@material-ui/icons/Star';

export default class TracksComponent extends PureComponent {
    constructor(props){
        super(props)
        this.state={
            removeConfirm: false,
            trackToRemove: null
        }
    }

    removeTrack = async () => {
        const {trackToRemove} = this.state;
        if(trackToRemove){
            this.props.removeTrack(trackToRemove)
        }
        this.setState({removeConfirm: false, trackToRemove: null})
    }

    hideRemoveDialog = () => {
        this.setState({removeConfirm: false, trackToRemove: null})
    };

    openRemoveDialog = (track) => {
        this.setState({removeConfirm: true, trackToRemove:track})
    }

    setPriority = (track) => {
        if (track.isPriority) {
            this.props.removePriority(track)
        } else {
            this.props.addPriority(track)
        }
    };

    render() {
        const {pendingTracks, shuffle, playedTracks, currentTrack, setCurrentTrack, replayTrack} = this.props;
        return (
            <div style={{height: '100%', overflow: 'auto', display: 'flex', flexDirection: 'row'}}>
                <Dialog
                    key={'removeDialog'}
                    open={this.state.removeConfirm}
                    onClose={this.hideRemoveDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Remove track?"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure you want to delete this track from the list of registered tracks? This action can't be undone
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.hideRemoveDialog} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={this.removeTrack} color="primary" autoFocus>
                            Remove
                        </Button>
                    </DialogActions>
                </Dialog>
                <Divider orientation="vertical"/>
                <List
                    className={"list"}
                    disablePadding
                    subheader={
                        <ListSubheader disableSticky
                                       style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}
                                       component="div" id="nested-list-subheader">
                            Pending tracks({pendingTracks.length}):
                            <Button endIcon={<Shuffle/>} onClick={shuffle} size={"small"}>Shuffle</Button>
                        </ListSubheader>
                    }
                    style={{height: '100%', width: '50%', overflow: 'scroll'}}>
                    {pendingTracks.map((track, index) => {
                        return (
                            <Fragment key={track.track_id}>
                                {index === 0 ? <Divider component="li"/> : null}
                                <ListItem selected={currentTrack && (track.track_id === currentTrack.track_id)}
                                          onClick={() => setCurrentTrack(track)} button>
                                    {currentTrack && (track.track_id === currentTrack.track_id)
                                        ? <ListItemIcon>
                                            <Tooltip title={"CURRENT TRACK"}>
                                                <PlayArrowIcon/>
                                            </Tooltip>
                                        </ListItemIcon>
                                        : null}
                                    <ListItemText
                                        primary={`${index+1}. ${track.track_name}`}
                                        secondary={`by ${track.artist_name}`}
                                    />
                                    <ListItemSecondaryAction>
                                        <IconButton onClick={() => this.setPriority(track)} edge="end"
                                                    aria-label="delete">
                                            {track.isPriority
                                                ? <Tooltip title={"UNMARK"}><Star/></Tooltip>
                                                : <Tooltip title={"MARK AS PRIORITY"}><StarBorder/></Tooltip>
                                            }
                                        </IconButton>
                                        <Tooltip title={"Remove track"}>
                                            <IconButton onClick={() => this.openRemoveDialog(track)} edge="end"
                                                        aria-label="delete">
                                                <RemoveIcon/>
                                            </IconButton>
                                        </Tooltip>
                                    </ListItemSecondaryAction>
                                </ListItem>
                                <Divider component="li"/>
                            </Fragment>
                        )
                    })}
                </List>
                <Divider orientation="vertical"/>
                <List className={"list"} disablePadding
                      subheader={
                          <ListSubheader disableSticky component="div" id="nested-list-subheader">
                              Played tracks:
                          </ListSubheader>
                      }
                      style={{height: '100%', width: '50%', overflow: 'scroll'}}>
                    {playedTracks.map((track, index) => {
                        return (
                            <Fragment key={track.track_id}>
                                {index === 0 ? <Divider component="li"/> : null}
                                <ListItem button>
                                    <ListItemText
                                        primary={`${track.order|| index + 1}. ${track.track_name}`}
                                        secondary={`by ${track.artist_name}`}
                                    />
                                    <ListItemSecondaryAction>
                                        <Tooltip title={"REPLAY track"}>
                                            <IconButton onClick={() => replayTrack(track)} edge="end"
                                                        aria-label="delete">
                                                <ReplayIcon/>
                                            </IconButton>
                                        </Tooltip>
                                    </ListItemSecondaryAction>
                                </ListItem>
                                <Divider component="li"/>
                            </Fragment>
                        )
                    })}
                </List>
            </div>
        )
    }
}